SharedMdl.directive('isResolve', [ '$transitions', function($transitions){
	return {
		restrict: 'A',
		link: function( scope, element, attrs ){
			$transitions.onStart({}, function ( transition ) {

				var views = transition.views();

				angular.forEach(views, function(view){
					if ( view.viewDecl.$uiViewName === 'filters' && !transition.$from().abstract )
						return;

					if ( view.viewDecl.$uiViewName != attrs.uiView )
						return;


					element.addClass('loading');
				});
			});
			$transitions.onFinish({}, function (transition) {
				//self.loading = false;
				//console.log(transition.Views())
				//element.removeClass('loading');
			});
		}
	}
}]);